/**
 * @ngdoc object
 * @name MainNavigationComponent
 * @requires $state
 * @description A resuable compent for Pulse navigation
 */

(function(){
  'use strict';

  angular.module('pulse').component('pulseMainNav', {
    templateUrl : 'views/common/components/mainnav.html',
    bindings : {'applications': '<',
                'user': '<',
                'projects': '<',
                'applinks': '<',
                'settingsmenuitems': '<'},
    controller : Controller
  });

  Controller.$inject = ['$log', '$state', 'Users', '$rootScope'];

  function Controller($log, $state, Users, $rootScope){
    var ctrl = this;

    ctrl.vm = {};

    ctrl.vm.nav = {};

    ctrl.vm.nav.state = $state;

    ctrl.vm.nav.applications = ctrl.applications;

    ctrl.vm.nav.features = {};

    const permissionNames = $rootScope.permissionNames;
    ctrl.vendorSettings = [];
    const isImpersonateBanner = localStorage.getItem('toggle-impersonate-banner');

      if (isImpersonateBanner === null) {
          ctrl.vm.nav.showImpersonateBanner = true;
      } else {
          ctrl.vm.nav.showImpersonateBanner = isImpersonateBanner === 'true';
      }

      ctrl.vm.nav.toggleUserBanner = function() {
          ctrl.vm.nav.showImpersonateBanner = !ctrl.vm.nav.showImpersonateBanner;
          localStorage.setItem('toggle-impersonate-banner', ctrl.vm.nav.showImpersonateBanner);
      }


    // Recompute settings items once root.app resolve sets storage.project, which arrives after $onInit.
    var offProjectWatch = $rootScope.$watch('storage.project', function(newProject, oldProject) {
        if (newProject !== oldProject && newProject && Object.keys(newProject).length > 0) {
            ctrl.vm.nav.settingsmenuitems = ctrl.vm.nav.getSettingsMenuItem(ctrl.settingsmenuitems);
        }
    });

    ctrl.$onDestroy = function() {
        offProjectWatch();
    };

    ctrl.$onInit = function(){
       ctrl.vm.nav.features = (ctrl.user.hasOwnProperty('features') === true) ? ctrl.user.features : {};
       ctrl.vm.nav.settingsmenuitems = ctrl.vm.nav.getSettingsMenuItem(ctrl.settingsmenuitems)
    };

    ctrl.vm.nav.saveFileManagerFeature = function (){
      $log.log('saveFileManagerFeature');

      var params = {
          'organizationID': ctrl.user.organization.id,
          'userID': ctrl.user.id
      };

      params.features = {'new_filemanager': false};
      var promise = Users.OrganizationUser.saveUser(params).$promise;
      promise.then(function(user) {
          $log.log('Users.OrganizationUser.saveUser Success', user);
          ctrl.vm.nav.features = user.features;

          // if the old file manager feature is set to false we redirect to the old file manager app
          if(!user.features.new_filemanager) {
              var new_location = window.location.href;
              new_location = new_location.replace('/filemanagerv2/#', '/filemanager/#');
              window.location.href = new_location;
          }
      },
      function(error) {
          $log.log('Users.OrganizationUser.saveUser Error', error);
      });
    };


    /**
     * Return setting menu items on base of the user permissions.
     * If user don't have permissions then return empty array.
     * @param {Array<Object>} settingsMenuItems
     * @returns { object } settingsMenuItems : menu option to display
     * @note This method is used for FMV2
     */
    ctrl.vm.nav.getSettingsMenuItem = function(settingsMenuItems) {
      const projectPermissions = Object.keys($rootScope.storage.project).length > 0 ? $rootScope.storage.project.permissions : [];
      if (projectPermissions.indexOf(permissionNames.FileManagerAdmin) !== -1) {
          return settingsMenuItems;
      } else if (projectPermissions.indexOf(permissionNames.VFXAdminVendor) !== -1) {
          return settingsMenuItems.filter(item => item.name === 'Vendors');
      }
      return [];
    }

    /**
     * Setting dropdown will be visible if a user has `filemanger:admin` or `admin vendor` permissions.
     * @returns { boolean } true/false : true will show settings dropdown on UI
     * @note This method is used for FMV2
     */
    ctrl.vm.nav.isSettingMenuVisible = function() {
        const projectPermissions = Object.keys($rootScope.storage.project).length > 0 ? $rootScope.storage.project.permissions : [];

        if (projectPermissions.indexOf(permissionNames.FileManagerAdmin) > -1 || projectPermissions.indexOf(permissionNames.VFXAdminVendor) > -1) {
            return true;
        }
        return false;
    }

  }
})();
